import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import {
  knownFacebookGroupName,
  splitFacebookUrls,
} from '../lib/facebookLinks'

interface Props {
  text: string
  className?: string
}

/**
 * Renders free text with Facebook URLs replaced by short outbound links.
 * Only used for read-only contact / details display — not edit mode.
 */
export function LinkedText({ text, className }: Props) {
  const { t } = useTranslation()
  const parts = splitFacebookUrls(text)

  return (
    <span className={className}>
      {parts.map((part, index) => {
        if (part.type === 'text') {
          return <Fragment key={index}>{part.value}</Fragment>
        }

        const groupName = knownFacebookGroupName(part.groupId)
        const label = groupName
          ? t('links.fromFacebookGroup', { group: groupName })
          : t('links.fromFacebook')

        return (
          <a
            key={index}
            className="smart-external-link"
            href={part.href}
            target="_blank"
            rel="noopener noreferrer"
          >
            {label}
          </a>
        )
      })}
    </span>
  )
}
